import React from 'react';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
// import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import './index.scss';
import { CommonBaseTable } from '@home/components/CommonBaseTable';
import { agentDataFormat } from '@/pages/aigc/utils/utils';
import { useMount, useUpdate } from 'ahooks';

export default function (props: any) {
  const {
    tableInfo,
    height
  } = props;

  // 表格中不同类型的单元格宽度映射
  // const widthMap: Record<string, number> = {
  //   day: 132, // 设计稿为111px，实际测试发现win需118px、mac需122px才能在7列时完整显示例如'2025-04-01'的日期
  //   string: 129, // 设计稿为130px
  //   thousandsInit: 143,
  //   percent2Decimal: 86,
  // };

  const { columnsInfo = [], data: tableData = [] } = tableInfo;

  // 优化后的自定义排序器函数
  const customSorter = (a: '' | number, b: '' | number,) => {
    // 将空值当作最小值处理，排在前面
    const aVal = a === '' ? Number.MIN_SAFE_INTEGER : a;
    const bVal = b === '' ? Number.MIN_SAFE_INTEGER : b;
    
    // 按数值大小排序
    return aVal - bVal;
  };
  const updatae = useUpdate();

  useMount(() => {
    updatae();
  });

  const columns = columnsInfo?.map((info: any, index: number) => {
    const { column_date_type, origin_name,display_name, name, origin_type: originType, isDimension } = info || {};
    const textAlignStyle = ['day', 'string'].includes(column_date_type) ? 'left' : 'right';
    // 第一项强制锁定，前置条件长度大于等于7 (设计稿为>7，取等保证7列能完整显示，不出现滚动条)
    const isLock = columnsInfo?.length >= 7;
    const tisMsgId = `dba-table-ellipsis-${origin_name}-${display_name}-${index}-${Math.random().toString(36).substring(2, 9)}`;
    return {
      code: isDimension ? display_name : origin_name,
      name, // 添加 name 属性供 autoColumnWidth 使用
      title: <EllipsisTextBubble text={`${name}${''}`} referenceElement={document.querySelector(`.${tisMsgId}`)}  ellipsisLineClamp={1} className={`dba-table-ellipsis ${tisMsgId}`}  overlayClassName='dba-nav-menu-overlay'/>,
      ...(index === 0 && isLock ? { lock: true } : {}),
      // 自适应宽度暂未实现，暂时对【超过7列】时，<游戏名称>列做特殊宽度限制
      // ...(isLock ? { width: getColumnWidth() } : {}),
      align: textAlignStyle,
      features: { 
        sortable: originType === 'float' ? customSorter : true 
      },
      // width: 'auto',
      // maxWidth: 300,
      // minWidth: 150,
      render(record: any, cvm: any) {
        return (
          <EllipsisTextBubble 
            text={`${agentDataFormat({
              value: cvm[display_name] || cvm[origin_name],
              formatRule: info?.column_date_type,
              isDate: info?.isDate,
            })}`}
            overlayClassName='dba-nav-menu-overlay'
            ellipsisLineClamp={1} 
          />
        );
      },
    };
  });
  return (
    <CommonBaseTable
      primaryKey="origin_name"
      dataSource={tableData}
      className={'dba-chart-message-table'}
      columns={columns}
      tableConfig={{
        isOpenInitialSort: true,
        tableHeight: height,
        isSortKeepDataSource: false,
        isShowPagination: false,
        stickyScrollHeight: 4,
        // defaultColumnWidth: 'auto',
      }}

      featConfig={{
        // 启用自动列宽调整
        autoColumnWidth: {
          maxWidth: 600, // 最大列宽 300px
          minWidth: 70,  // 最小列宽 80px
          padding: 20,   // 单元格内容左右边距
          headerPadding: 20, // 表头左右边距
          sortWidth: 20,
          bufferWidth: 10,// 补全其他宽度，调试兜底
          fontSize: 14,  // 字体大小
          // 和原表格保持一致
          fontFamily: 'Roboto,"system-ui",Microsoft YaHei,Helvetica,Arial,Hiragino Sans GB,Heiti SC,Helvetica Neue,WenQuanYi Micro Hei,sans-serif',
          fontWeight: 900
        },
        // 列宽调整功能
        columnResize: {
          fallbackSize: 300,
          minSize: 70,
          maxSize: 600,
        },
      }}
      
    />
  );
}